import { z } from 'zod';
import { offerRequestPartnerMatchingStatusSchema } from './offerRequestPartnerMatchingStatus.js';
export const declineMatchingResponseSchema = z.object({
    matchingUuid: z.uuid(),
    status: offerRequestPartnerMatchingStatusSchema.extract(['Rejected']),
});
